import apiClient from '../apiClient';
import { POST_CREATE_TOUR_TRANSACTION_URL } from '../apiUrl';

const postCreateTourTransactionApi = data => {
  return apiClient.post(POST_CREATE_TOUR_TRANSACTION_URL, data);
};

export default postCreateTourTransactionApi;
